/* NUANSE: saldo de boas-vindas de 5 € (código real SALDO5 na Shopify: 5 €, a partir de 40 €, 1 vez por cliente).
   v2 (13/10): o saldo só se guarda com email. O form é o {% form 'customer' %} do snippet nuanse-saldo-form
   (POST nativo com o hCaptcha da Shopify, tags newsletter + nuanse-saldo-5); depois do envio a Shopify volta
   à página com ?customer_posted=true e este ficheiro mostra o código e aplica-o (/discount/SALDO5).
   Mantém a API usada pelo carrinho: NZSALDO.has(), NZSALDO.reveal(), localStorage "nz-saldo".
   ponytail: quem já tinha guardado o saldo na v1 (sem email) continua com ele. */
(function () {
  "use strict";
  var K = "nz-saldo", PEND = "nz-saldo-pending", SK = "nz-saldo-slide", CODE = (window.NZL && NZL.SALDO_CODE) || "SALDO5";
  // quem chega de anúncio (Meta, Shop) ou de um email nosso (utm_medium=email) não vê o popup nesta sessão; os outros só a partir da 2.ª página vista
  var AD = "nz-from-ad", PV = "nz-pv";
  try {
    if (/[?&]utm_source=(meta|facebook|fb|ig|instagram|shop|shop_app|klaviyo|email)\b/i.test(location.search) || /[?&]utm_medium=e-?mail\b/i.test(location.search) || /(^|\.)(shop\.app|facebook\.com|fb\.com|instagram\.com)$/i.test((document.referrer && new URL(document.referrer).hostname) || "")) sessionStorage.setItem(AD, "1");
  } catch (e) {}
  function fromAd() { try { return !!sessionStorage.getItem(AD); } catch (e) { return false; } }
  function views() { try { return +sessionStorage.getItem(PV) || 0; } catch (e) { return 2; } }
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  function read() { try { return JSON.parse(localStorage.getItem(K)) || null; } catch (e) { return null; } }
  function write(v) { try { localStorage.setItem(K, JSON.stringify(v)); } catch (e) {} }
  window.NZSALDO = { has: function () { var v = read(); return !!(v && v.saved && !v.used); } };

  function amount() { return NZL.money(NZL.SALDO).replace(/[.,]00(?= €|$)/, ""); }
  function minTxt() { return NZL.money(Math.ceil(NZL.SALDO_MIN)).replace(/[.,]00(?= €|$)/, ""); }

  function pill() {
    // no mobile o lado direito só tem pesquisa e carrinho; o saldo vai para o lado do menu para o logótipo respirar
    var r = document.querySelector(".hdr__l"); if (!r || document.getElementById("saldo-pill")) return;
    var b = document.createElement("button");
    b.id = "saldo-pill"; b.className = "saldo-pill"; b.type = "button"; b.setAttribute("data-open", "cart");
    b.setAttribute("aria-label", L("O teu saldo de " + amount() + ", abrir o carrinho", "Your " + amount() + " credit, open basket"));
    b.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-1.5-3-5-3-5-1s3 1 5 1c2 0 5 1 5-1s-3.5-2-5 1" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg><span class="sp-l">' + L("Saldo ", "Credit ") + '</span>' + amount();
    r.appendChild(b);
  }
  function syncPdp() { document.querySelectorAll("[data-saldo-pdp]").forEach(function (el) { el.hidden = !NZSALDO.has(); }); }
  function count(el, to, ms, done) {
    if (reduce) { el.textContent = amount(); done && done(); return; }
    var t0 = performance.now();
    (function f(t) {
      var k = Math.min(1, (t - t0) / ms), e = 1 - Math.pow(1 - k, 3);
      el.textContent = k < 1 ? NZL.money(to * e) : amount();
      if (k < 1) requestAnimationFrame(f); else done && done();
    })(t0);
  }
  // o desconto fica no cookie da sessão e a Shopify aplica-o sozinho no checkout
  function applyCode() { try { fetch("/discount/" + CODE, { credentials: "same-origin" }).catch(function () {}); } catch (e) {} }
  function saved() {
    write({ saved: true, email: true, at: Date.now() }); pill(); syncPdp(); applyCode();
    if (window.NZAPP && NZAPP.renderAgain) NZAPP.renderAgain();
  }

  var src = function () { return document.getElementById("nz-saldo-form"); };
  var TABX = "nz-saldo-tabx";
  function legal() {
    return '<p class="nzs__legal" id="nzs-legal">' + L(
      "Sem prazo. 1 utilização por cliente, não acumula com o Leva 2 nem com o Leva 3. Ao guardar, aceitas receber emails da NUANSE com novidades e ofertas; sais quando quiseres. <a href=\"/policies/privacy-policy\">Privacidade</a>",
      "No expiry. One use per customer, can't be combined with Buy 2 or Buy 3. By saving, you agree to receive emails from NUANSE with news and offers; unsubscribe anytime. <a href=\"/policies/privacy-policy\">Privacy</a>") + "</p>";
  }
  var GIFT = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-1.5-3-5-3-5-1s3 1 5 1c2 0 5 1 5-1s-3.5-2-5 1" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';
  // cartão: verso com o monograma, frente com o valor (garantido e dito antes de virar: a surpresa é a cerimónia, não o dinheiro)
  function card(flipped, front) {
    return '<button type="button" class="nzc' + (flipped ? " on" : "") + '" aria-pressed="' + !!flipped + '" aria-label="' + L("Abrir o cartão-presente", "Reveal your £5 credit") + '"' + (flipped ? " disabled" : "") + ">" +
      '<span class="nzc__in"><span class="nzc__back" aria-hidden="true"><b>N</b><small>NUANSE</small></span>' +
      '<span class="nzc__front"><small>' + L("Saldo", "Your credit") + '</small><span class="nzs__n">' + front + "</span><em>" + L("De nós para ti", "From us to you") + "</em></span></span></button>";
  }
  function formBits(box, err) {
    var f = src();
    box.innerHTML = '<p class="nzs__h2">' + L(amount() + " na tua primeira encomenda", amount() + " off your first order") + "</p>" +
      '<p class="nzs__p">' + L("Deixa o email e guardamos o saldo na tua carteira NUANSE.", "Leave your email and we'll keep it in your NUANSE wallet.") + "</p>";
    if (!f) return;
    box.appendChild(f);
    box.insertAdjacentHTML("beforeend", legal());
    var inp = f.querySelector(".nzs-in"), btn = f.querySelector(".nzs-go"), eb = f.querySelector(".nzs-err"), lb = f.querySelector(".nzs-lbl");
    btn.textContent = L("Guardar os meus " + amount(), "Save my " + amount());
    if (lb) lb.textContent = L("O teu email", "Your email");
    function showErr(t) { eb.textContent = t; eb.hidden = false; inp.setAttribute("aria-invalid", "true"); }
    if (err) showErr(err);
    if (!f.dataset.nzs) {
      f.dataset.nzs = "1";
      inp.addEventListener("input", function () { eb.hidden = true; inp.removeAttribute("aria-invalid"); });
      // antes do hCaptcha: email inválido não sai daqui
      f.addEventListener("submit", function (e) {
        var v = inp.value.trim(); inp.value = v;
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
          e.preventDefault(); e.stopImmediatePropagation();
          showErr(L("Escreve um email válido, por exemplo nome@gmail.com.", "Please enter a valid email, for example name@gmail.com.")); inp.focus(); return;
        }
        try { sessionStorage.setItem(PEND, "1"); } catch (x) {}
        btn.setAttribute("aria-busy", "true"); btn.textContent = L("A guardar…", "Saving…");
      });
    }
  }
  var opener = null;
  // v4 (15/10): "Encontra os 3 corações". O valor (5 € / £5) é dito antes de jogar e é igual para todas: o jogo é a cerimónia, não a sorte.
  // Passos: 1 jogo (6 cartões; v5: cada toque dá coração, 3 toques = 3 corações) · 2 "Para quem é a peça?" (tag de cliente, opcional) · 3 email.
  // Reduced-motion: os cartões já vêm virados e há um botão "Continuar". "Prefiro só o código" salta o jogo (alternativa acessível).
  var WHO = { mim: "nz-para-mim", prenda: "nz-prenda", memoria: "nz-memoria" };
  var HEART = '<svg viewBox="0 0 32 32" width="34" height="34" aria-hidden="true"><path d="M16 28S4 20.5 4 12.2C4 8.3 7 5.5 10.4 5.5c2.4 0 4.4 1.3 5.6 3.2 1.2-1.9 3.2-3.2 5.6-3.2C25 5.5 28 8.3 28 12.2 28 20.5 16 28 16 28z" fill="currentColor"/><g fill="#15524d"><ellipse cx="16" cy="18" rx="3.1" ry="2.6"/><circle cx="11.6" cy="13.6" r="1.35"/><circle cx="14.4" cy="11.6" r="1.35"/><circle cx="17.6" cy="11.6" r="1.35"/><circle cx="20.4" cy="13.6" r="1.35"/></g></svg>';
  var PICS = null;
  // fotos de peças reais para os 3 cartões sem coração (o "produto em cena"); sem fotos, o cartão mostra só o monograma
  function pics() {
    if (PICS) return PICS;
    PICS = fetch("/collections/caes/products.json?limit=8").then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (d) {
      return (d.products || []).filter(function (p) { return p.images && p.images.length; }).slice(0, 3).map(function (p) {
        var s = p.images[0].src; return { src: s + (s.indexOf("?") > -1 ? "&" : "?") + "width=240", t: p.title };
      });
    }).catch(function () { return []; });
    return PICS;
  }
  function confetti(host) {
    if (reduce) return;
    for (var i = 0; i < 9; i++) {
      var s = document.createElement("i"); s.className = "nzg-cf";
      s.style.setProperty("--x", (Math.random() * 220 - 110).toFixed(0) + "px");
      s.style.setProperty("--y", (-60 - Math.random() * 90).toFixed(0) + "px");
      s.style.setProperty("--r", (Math.random() * 540 - 270).toFixed(0) + "deg");
      s.style.animationDelay = (i * 18) + "ms";
      host.appendChild(s);
    }
    setTimeout(function () { host.querySelectorAll(".nzg-cf").forEach(function (x) { x.remove(); }); }, 1300);
  }
  function reveal(slide, mode, err) {
    if (document.querySelector(".nzs")) return;
    opener = document.activeElement;
    hideTab(true);
    var done = mode === "done";
    var m = document.createElement("div");
    m.className = "nzs" + (document.body.classList.contains("is-calm") ? " nzs--calm" : "");
    m.setAttribute("role", "dialog"); m.setAttribute("aria-modal", "true"); m.setAttribute("aria-labelledby", "nzs-title");
    m.innerHTML = '<div class="nzs__card"><span class="nzs__grab" aria-hidden="true"></span>' +
      '<div class="nzs__dots" aria-hidden="true"><i></i><i></i><i></i></div>' +
      '<button class="nzs__x" type="button" aria-label="' + L("Fechar", "Close") + '">✕</button><div class="nzs__body"></div>' +
      '<p class="nzs__sr" aria-live="polite"></p></div>';
    var cd = m.firstChild, body = cd.querySelector(".nzs__body"), live = cd.querySelector(".nzs__sr"), dots = cd.querySelectorAll(".nzs__dots i");
    function step(n) { [].forEach.call(dots, function (d, i) { d.classList.toggle("on", i < n); }); cd.querySelector(".nzs__dots").hidden = done; }
    function focusFirst(sel) { setTimeout(function () { var t = body.querySelector(sel) || cd.querySelector(".nzs__x"); t.focus({ preventScroll: true }); }, reduce ? 0 : 60); }
    var NO = '<button class="nzs__no" type="button" data-nzs-close>' + L("Agora não", "Not now") + "</button>";

    // passo 1: o jogo
    function game() {
      step(1);
      var amt = '<b class="nzs__v">' + amount() + "</b>";
      body.innerHTML = '<h2 class="nzs__t" id="nzs-title">' + L("Encontra os 3 corações", "Find the 3 hearts") + "</h2>" +
        '<p class="nzs__i">' + L("Todas as clientes ganham " + amt + " na primeira encomenda. É só virar.", "Everyone gets " + amt + " off their first order. Just flip.") + "</p>" +
        '<div class="nzg" role="group" aria-label="' + L("6 cartões", "6 cards") + '"></div>' +
        '<p class="nzg__n" aria-hidden="true"><span>0</span>/3</p>' +
        '<div class="nzg__cta"></div>' +
        '<button class="nzs__skip" type="button" data-nzs-skip>' + L("Prefiro só o código", "Just give me the code") + "</button>" + NO;
      var g = body.querySelector(".nzg"), cnt = body.querySelector(".nzg__n span"), taps = 0, hearts = 0, cards = [];
      for (var i = 0; i < 6; i++) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "nzg__c";
        b.setAttribute("aria-label", L("Cartão " + (i + 1) + " de 6, virar", "Card " + (i + 1) + " of 6, flip"));
        b.innerHTML = '<span class="nzg__in"><span class="nzg__b" aria-hidden="true"><b>N</b></span><span class="nzg__f" aria-hidden="true"></span></span>';
        g.appendChild(b); cards.push(b);
      }
      var photos = [];
      pics().then(function (p) { photos = p.slice(); });
      function face(b, heart) {
        var f = b.querySelector(".nzg__f");
        if (heart) { f.className = "nzg__f nzg__f--h"; f.innerHTML = HEART; }
        else {
          var ph = photos.shift();
          f.className = "nzg__f nzg__f--p";
          f.innerHTML = ph ? '<img src="' + ph.src + '" alt="">' : "<b>N</b>";
        }
      }
      function finish() {
        var cta = body.querySelector(".nzg__cta");
        body.querySelector("[data-nzs-skip]").hidden = true;
        if (!m.classList.contains("nzs--calm")) confetti(g);
        try { if (navigator.vibrate) navigator.vibrate([12, 60, 18]); } catch (x) {}
        // os cartões que ficaram por virar mostram peças diferentes, um a um (não contam como jogada)
        var rest = cards.filter(function (c) { return !c.classList.contains("on"); });
        rest.forEach(function (c, k) {
          setTimeout(function () { face(c, false); c.classList.add("on", "rest"); c.setAttribute("aria-label", L("Peça NUANSE", "NUANSE piece")); }, reduce ? 0 : 260 + k * 170);
        });
        setTimeout(function () {
          cta.innerHTML = '<p class="nzg__won">' + L("Encontraste os 3!", "You found all 3!") + ' <b class="nzg__amt">' + NZL.money(0) + "</b> " + L("são teus.", "is yours.") + "</p>" +
            '<button class="nzs-go" type="button" data-nzs-next>' + L("Guardar os meus ", "Claim my ") + amount() + "</button>";
          count(cta.querySelector(".nzg__amt"), NZL.SALDO, 700);
          setTimeout(function () { var x = cta.querySelector("[data-nzs-next]"); if (x) x.focus({ preventScroll: true }); }, reduce ? 0 : 750);
        }, reduce ? 0 : 260 + rest.length * 170 + 120);
      }
      if (reduce) {
        // sem movimento: tudo já à vista, 3 corações + 3 peças, e um botão
        pics().then(function (p) {
          photos = p.slice();
          cards.forEach(function (b, k) {
            var h = k < 3;
            face(b, h); b.classList.add("on"); b.disabled = true;
            b.setAttribute("aria-label", L("Cartão " + (k + 1) + ": ", "Card " + (k + 1) + ": ") + (h ? L("coração", "heart") : L("peça", "piece")));
          });
          cnt.textContent = "3"; finish();
        });
        return;
      }
      g.addEventListener("click", function (e) {
        var b = e.target.closest(".nzg__c"); if (!b || b.disabled || hearts >= 3 || g.classList.contains("busy")) return;
        // v5 (18/10): onde a pessoa tocar aparece um coração (3 toques = 3 corações). O valor é igual para todas e está dito acima.
        var last = hearts === 2;
        g.classList.add("busy"); b.disabled = true; b.classList.add("pick");
        face(b, true);
        try { if (navigator.vibrate) navigator.vibrate(last ? [8, 40, 8] : 10); } catch (x) {}
        // antecipação: 220 ms nos dois primeiros, 520 ms (tremer) no 3.º
        if (last) g.classList.add("tense");
        setTimeout(function () {
          g.classList.remove("busy", "tense"); b.classList.remove("pick");
          b.classList.add("on", "hit");
          b.setAttribute("aria-label", L("Coração", "Heart"));
          hearts++; cnt.textContent = String(hearts);
          var n = cnt.parentNode; n.classList.remove("bump"); void n.offsetWidth; n.classList.add("bump");
          live.textContent = L("Coração " + hearts + " de 3", "Heart " + hearts + " of 3");
          if (hearts === 3) { cards.forEach(function (c) { c.disabled = true; }); setTimeout(finish, 380); }
        }, last ? 520 : 220);
      });
      focusFirst(".nzg__c");
    }

    // passo 2: para quem é a peça (1 toque, opcional; vira tag de cliente no form)
    function who() {
      step(2);
      body.innerHTML = '<h2 class="nzs__t" id="nzs-title">' + L("Ganhaste " + amount() + ". Para quem é a peça?", "Your " + amount() + " is in. Who's it for?") + "</h2>" +
        '<div class="nzw">' +
        '<button type="button" class="nzw__o" data-who="mim">' + L("Para mim", "For me") + "</button>" +
        '<button type="button" class="nzw__o" data-who="prenda">' + L("Para oferecer", "A gift") + "</button>" +
        '<button type="button" class="nzw__o" data-who="memoria">' + L("Para lembrar alguém especial", "To remember someone") + "</button></div>" +
        '<button class="nzs__skip" type="button" data-who="">' + L("Saltar", "Skip") + "</button>";
      focusFirst(".nzw__o");
    }
    function setWho(k) {
      var f = src(), t = f && f.querySelector("input[name='contact[tags]']");
      if (t) t.value = t.value.split(",").filter(function (x) { return !/^nz-(para-mim|prenda|memoria)$/.test(x); }).concat(WHO[k] ? [WHO[k]] : []).join(",");
      // memória: tom calmo no resto (sem confetes, cor serena)
      if (k === "memoria") m.classList.add("nzs--calm");
    }

    // passo 3: email
    function form(e2) {
      step(3);
      body.innerHTML = card(true, amount()) +
        '<h2 class="nzs__t nzs__t--s" id="nzs-title">' + L("Os teus " + amount() + " estão guardados aqui", "Your " + amount() + " is waiting here") + "</h2>" +
        '<div class="nzs__after"></div>' + NO;
      var after = body.querySelector(".nzs__after");
      formBits(after, e2);
      var h2 = after.querySelector(".nzs__h2"); if (h2) h2.remove();
      var p = after.querySelector(".nzs__p");
      if (p) p.textContent = L("Deixa o email e guardamos o saldo na tua carteira NUANSE.", "Leave your email and we'll keep it in your NUANSE wallet.");
      focusFirst(".nzs-in");
    }
    function success() {
      body.innerHTML = '<h2 class="nzs__t" id="nzs-title">' + L("Está guardado.", "Saved.") + "</h2>" + card(true, CODE) +
        '<p class="nzs__p">' + L("Já está no teu carrinho. Vê as peças mais oferecidas.", "It's already in your basket. See our most-gifted pieces.") + "</p>" +
        '<a class="nzs-go nzs-go--a" href="/collections/prendas" data-link data-nzs-close>' + L("Ver as mais oferecidas", "See the most-gifted") + "</a>" +
        '<button class="nzs__no" type="button" data-nzs-close>' + L("Continuar a ver", "Keep browsing") + "</button>";
      cd.querySelector(".nzs__dots").hidden = true;
      focusFirst(".nzs-go");
    }

    if (done) success(); else if (err || mode === "form") form(err); else game();
    document.body.appendChild(m);
    document.documentElement.classList.add("nzs-lock");
    requestAnimationFrame(function () { requestAnimationFrame(function () { m.classList.add("on"); liftWidgets(cd); }); });

    function close() {
      if (!done && !NZSALDO.has()) write({ saved: false, dismissed: Date.now() });
      var f = cd.querySelector("#nz-saldo-form"), home = document.getElementById("nz-saldo-src");
      m.classList.remove("on");
      document.documentElement.classList.remove("nzs-lock");
      document.removeEventListener("keydown", key);
      liftWidgets(null);
      setTimeout(function () { if (f && home) home.appendChild(f); m.remove(); if (!done && !NZSALDO.has() && !fromAd()) { tab(); relabel(); hideTab(false); } if (opener && opener.focus && document.contains(opener)) opener.focus({ preventScroll: true }); }, reduce ? 0 : 400);
    }
    function key(e) {
      if (e.key === "Escape") return close();
      if (e.key !== "Tab") return;
      var fs = [].filter.call(cd.querySelectorAll("button:not([disabled]), input:not([type=hidden]), a[href]"), function (x) { return x.offsetParent !== null; });
      if (!fs.length) return;
      if (e.shiftKey && document.activeElement === fs[0]) { e.preventDefault(); fs[fs.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === fs[fs.length - 1]) { e.preventDefault(); fs[0].focus(); }
    }
    cd.querySelector(".nzs__x").onclick = close;
    cd.addEventListener("click", function (e) {
      var t = e.target;
      if (t.closest("[data-nzs-close]")) close();
      else if (t.closest("[data-nzs-skip]")) form(null);
      else if (t.closest("[data-nzs-next]")) who();
      else if (t.closest("[data-who]")) { setWho(t.closest("[data-who]").getAttribute("data-who")); form(null); }
    });
    m.addEventListener("click", function (e) { if (e.target === m) close(); });
    document.addEventListener("keydown", key);
  }
  // widgets fixos de terceiros no canto (acessibilidade, chat): sobem para cima da folha enquanto está aberta, nunca se escondem
  var lifted = [];
  function liftWidgets(cd) {
    lifted.forEach(function (x) { x.style.translate = ""; }); lifted = [];
    if (!cd) return;
    setTimeout(function () {
      if (!document.contains(cd)) return;
      var top = cd.getBoundingClientRect().top;
      [].forEach.call(document.querySelectorAll("body > *, body > * > *"), function (el) {
        if (el.closest(".nzs, .nzs-tab, #shopify-pc__banner, #app")) return;
        if (getComputedStyle(el).position !== "fixed") return;
        var r = el.getBoundingClientRect();
        if (!r.width || r.width > innerWidth * 0.5 || r.bottom <= top) return;
        el.style.translate = "0 " + Math.round(top - r.bottom - 12) + "px"; lifted.push(el);
      });
    }, reduce ? 0 : 520);
  }
  window.NZSALDO.reveal = function () { reveal(false, NZSALDO.has() ? "done" : "form"); };

  // aba minimizada: pílula em baixo à esquerda, por cima da barra fixa de adicionar e nunca por cima do botão
  var tabEl = null;
  function hideTab(h) { if (tabEl) tabEl.classList.toggle("off", !!h); }
  // depois de fechar a folha a aba passa a "Os teus 5 €" (o saldo continua à espera)
  function tabTxt() { var v = read(), o = false; try { o = !!sessionStorage.getItem(SK); } catch (e) {} return (v && v.dismissed) || o ? L("Os teus " + amount(), "Your " + amount()) : L("Joga e ganha " + amount(), "Play for your " + amount()); }
  function relabel() { var s = tabEl && tabEl.querySelector(".nzs-tab__go span"); if (s) s.textContent = tabTxt(); }
  function tab() {
    try { if (sessionStorage.getItem(TABX)) return; } catch (e) {}
    if (tabEl || NZSALDO.has()) return;
    tabEl = document.createElement("div");
    tabEl.className = "nzs-tab";
    tabEl.innerHTML = '<button type="button" class="nzs-tab__go" aria-haspopup="dialog">' + GIFT + "<span>" + tabTxt() + "</span></button>" +
      '<button type="button" class="nzs-tab__x" aria-label="' + L("Fechar a oferta", "Dismiss the offer") + '">✕</button>';
    document.body.appendChild(tabEl);
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (tabEl) tabEl.classList.add("on"); }); });
    tabEl.querySelector(".nzs-tab__go").onclick = function () { reveal(true, "game"); };
    tabEl.querySelector(".nzs-tab__x").onclick = function () {
      try { sessionStorage.setItem(TABX, "1"); } catch (e) {}
      tabEl.remove(); tabEl = null;
    };
    // botão principal da PDP no ecrã: a aba sai do caminho; barra fixa visível: a aba sobe por cima dela
    var bar = document.getElementById("sticky-atc");
    var sync = function () {
      if (!tabEl) return;
      tabEl.classList.toggle("up", !!(bar && bar.classList.contains("on")));
      var atc = document.getElementById("atc"), r = atc && atc.getBoundingClientRect();
      tabEl.classList.toggle("hide", !!(r && r.height && r.bottom > 0 && r.top < innerHeight));
    };
    if (bar) new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ["class"] });
    addEventListener("scroll", sync, { passive: true });
    window.addEventListener("nz:page", function () { setTimeout(sync, 80); });
    sync();
  }

  function pdp() { return /\/products\//.test(location.pathname); }
  function bannerOpen() {
    var b = document.getElementById("shopify-pc__banner"); if (!b) return false;
    var cs = getComputedStyle(b); return cs.display !== "none" && cs.visibility !== "hidden" && b.getBoundingClientRect().height > 0;
  }
  function armSlide() {
    var shown = false, opened = false, busy = false, timer, pageT = Date.now();
    try { opened = !!sessionStorage.getItem(SK); } catch (e) {}
    document.addEventListener("click", function (e) { if (e.target.closest && e.target.closest("#atc, .atc, .bundle-card, [data-open='cart']")) busy = true; }, true);
    function ok() {
      // nunca a quem vem de anúncio, na advertorial, nas páginas de memória/luto (is-calm) nem depois de a cliente começar a comprar
      return !(busy || fromAd() || views() < 2 || NZSALDO.has() || document.body.classList.contains("is-advertorial") || document.body.classList.contains("is-calm"));
    }
    function showTab() {
      if (shown || !ok()) return;
      // não aparecer por cima do aviso de cookies: espera que a cliente responda
      if (bannerOpen()) { clearTimeout(timer); timer = setTimeout(showTab, 3000); return; }
      shown = true; clearTimeout(timer); tab();
    }
    function openSheet() {
      // na PDP só depois de 20 s na página (nunca sozinha antes disso)
      if (opened || !shown || !tabEl || !ok() || (pdp() && Date.now() - pageT < 19500) || document.querySelector(".nzs")) return;
      opened = true;
      try { sessionStorage.setItem(SK, "1"); } catch (e) {}
      reveal(true, "game");
    }
    function onScroll() {
      var h = document.documentElement.scrollHeight - innerHeight;
      if (h < 200) return;
      var k = scrollY / h;
      if (k >= 0.35) showTab();
      if (k >= 0.5) openSheet();
    }
    function onOut(e) { if (!e.relatedTarget && e.clientY <= 0) { showTab(); openSheet(); } }
    // aba aos 8 s ou 35% de scroll; a folha abre com toque na aba, intenção de saída (desktop), 20 s na 2.ª página ou 50% de scroll, 1 vez por sessão (nunca sozinha numa PDP)
    addEventListener("scroll", onScroll, { passive: true });
    if (matchMedia("(hover: hover) and (pointer: fine)").matches) document.addEventListener("mouseout", onOut);
    var auto;
    function arm20() { clearTimeout(auto); if (views() >= 2) auto = setTimeout(function () { showTab(); openSheet(); }, 20000); }
    timer = setTimeout(showTab, 8000); arm20();
    window.addEventListener("nz:page", function () {
      pageT = Date.now();
      arm20();
      if (!shown) { clearTimeout(timer); timer = setTimeout(showTab, 8000); }
      else hideTab(!ok());
    });
  }
  function boot() {
    var st = document.querySelector("[data-nzs-state]"), state = st ? st.getAttribute("data-nzs-state") : "";
    var posted = /[?&]customer_posted=true/.test(location.search), mine = false;
    try { mine = !!sessionStorage.getItem(PEND); sessionStorage.removeItem(PEND); } catch (e) {}
    if (posted) {
      // limpar o URL para o router da app e para não repetir ao recarregar
      try { history.replaceState(history.state, "", location.pathname + location.search.replace(/([?&])customer_posted=true&?/, "$1").replace(/[?&]$/, "")); } catch (e) {}
    }
    var v = read();
    if (posted && state === "ok") { saved(); if (mine || !v || !v.saved) reveal(true, "done"); }
    else if (posted && state === "err" && mine) reveal(true, "form", (st.getAttribute("data-nzs-msg") || "").trim() || L("Não foi possível guardar. Tenta de novo.", "We couldn't save it. Please try again."));
    else if (v && v.saved && !v.used) pill();
    syncPdp();
    // reaparece em cada mudança de página da app
    var app = document.getElementById("app"), lastP = null;
    var page = function () {
      if (location.pathname === lastP) return;
      lastP = location.pathname;
      try { sessionStorage.setItem(PV, String(views() + 1)); } catch (e) {}
      window.dispatchEvent(new Event("nz:page"));
    };
    page();
    if (app) new MutationObserver(function () { syncPdp(); page(); }).observe(app, { childList: true });
    // quem fechou volta a ver ao fim de 5 dias; quem guardou nunca mais
    v = read();
    if (!v || (!v.saved && v.dismissed && Date.now() - v.dismissed > 5 * 864e5)) armSlide();
    // fechou há menos de 5 dias: a folha não volta a abrir sozinha, mas fica o botão "Os teus 5 €"
    else if (!v.saved && v.dismissed && !fromAd()) setTimeout(function () { if (!document.body.classList.contains("is-calm")) tab(); }, 1500);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
